import {NgModule} from '@angular/core';
import {FormFieldModule} from '@components/form-field/form-field.module';
import {ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {ApparatusFormFieldsComponent} from './apparatus-form-fields.component';
import {ObjectsModalSelectModule} from '@components/objects-modal-select/objects-modal-select.module';
import {ApparatusFormFieldService} from './apparatus-form-field.service';
import {LayoutModule} from '../../layout-components/layout.module';
import {DirectivesModule} from '@helpers/directives/directives.module';
import {IconsModule} from '@lab365/icons';

/**
 * Модуль полей формы добавления оборудования
 */
@NgModule({
    declarations: [ApparatusFormFieldsComponent],
    exports: [ApparatusFormFieldsComponent],
    imports: [
        FormFieldModule,
        ReactiveFormsModule,
        CommonModule,
        ObjectsModalSelectModule,
        LayoutModule,
        DirectivesModule,
        IconsModule,
    ],
    providers: [
        ApparatusFormFieldService
    ]
})
export class ApparatusFormFieldsModule {}
